import { render, staticRenderFns } from "./fleg-comp-determinacion-de-las-coutas-obrero-patronales-bimestrales.vue?vue&type=template&id=7e82789a&lang=html&"
import script from "./fleg-comp-determinacion-de-las-coutas-obrero-patronales-bimestrales.vue?vue&type=script&lang=js&"
export * from "./fleg-comp-determinacion-de-las-coutas-obrero-patronales-bimestrales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports